import React, {useRef} from "react";
import SparklesIcon from "@heroicons/react/24/outline/SparklesIcon";
import Bot from "../../assets/images/bot.png";
import Button from "../button";

/**
 * The "Create from Document" call to action: pick a file, and the page's dialog reads it
 * and fills the form in.
 *
 * Owns the hidden file input as well as the button, because every page needs both and
 * wiring them together by hand is what made the two existing copies drift apart.
 *
 * `tooltip` is deliberately required and has no default. The button says what it does but
 * not what it accepts or what it fills in, and that differs per page — a bill reads a
 * receipt, recruiting reads a CDL. A page that cannot say which is a page whose users are
 * guessing.
 *
 * The caller's `onFileSelected` receives the raw change event and is responsible for
 * clearing `event.target.value`, so the same file can be picked twice in a row.
 */
export default function CreateFromDocumentButton({
                                                     tooltip,
                                                     accept,
                                                     onFileSelected,
                                                     hasPerm = true,
                                                     className = "btn btn-outline rounded-btn",
                                                     translate
                                                 }) {
    const inputRef = useRef(null);

    return (
        <>
            <input
                type="file"
                ref={inputRef}
                className="hidden"
                accept={accept}
                onChange={onFileSelected}
            />

            <Button
                hasPerm={hasPerm}
                className={className}
                onClick={() => inputRef.current?.click()}
                toolTip={tooltip}
            >
                <img src={Bot} className="w-5 h-5 mr-2 -ml-1 shrink-0" alt="bot"/>

                {translate("btn.create_from_document")}

                <SparklesIcon className="w-5 h-5 ml-2 -mr-1 shrink-0"/>
            </Button>
        </>
    );
}
